import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import AddQuestionModalContainer from 'modules/surveys/components/Questions/AddQuestion/AddQuestionModalContainer'

const AddQuestionInCategoryPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const { question_group_config_id, question_category_id, id } = useParams()

  const onClose = () =>
    navigate(navigation.processes.surveys.id.questions.fullPath({ id: String(id) }))

  return (
    <AddQuestionModalContainer
      surveyId={id ?? ''}
      onClose={onClose}
      questionGroupConfigId={question_group_config_id ?? ''}
      questionCategoryId={question_category_id ?? ''}
    />
  )
}

export default AddQuestionInCategoryPage
